import { useMeasures } from '../../../../../hooks/state/useMeasures'
import { LogsBarClassic, LogsBarRound, LogsBarSquare } from '../../model/log'

interface Props {
  isBackLog?: boolean
  logBarHeight: number
}

export const LogsBarOuter = ({
  isBackLog,
  logBarHeight,
}: Props): JSX.Element => {
  const { userWidth, depth, verandaTyp, frontBarTyp, indentBar, isQubus } =
    useMeasures()
  const spaceWidthNormal = isQubus
    ? userWidth
    : userWidth - verandaTyp.log.width
  return (
    <>
      {[...Array(2)].map((_, index) => {
        const spaceWidth =
          spaceWidthNormal -
          (isBackLog ? 0 : index ? indentBar.left * 2 : indentBar.right * 2)
        return (
          <group
            key={'LogBarOuter' + index}
            position={[
              0,
              0,
              isBackLog
                ? verandaTyp.log.depth / 2
                : depth - verandaTyp.log.depth / 2,
            ]}
          >
            {frontBarTyp === 'eckig' && (
              <LogsBarSquare
                logBarHeight={logBarHeight}
                position={[
                  (spaceWidth / 2) * (index ? -1 : 1),
                  logBarHeight / 2 + 0.005,
                  isBackLog ? 0 : 0,
                ]}
              />
            )}
            {frontBarTyp === 'rund' && (
              <LogsBarRound
                position={[
                  (spaceWidth / 2) * (index ? -1 : 1) +
                    verandaTyp.log.width / 2,
                  logBarHeight,
                  verandaTyp.log.depth / 2 - 0.02,
                ]}
                logBarHeight={logBarHeight}
              />
            )}

            {frontBarTyp === 'klassisch' && (
              <LogsBarClassic
                logBarHeight={logBarHeight}
                position={[
                  (spaceWidth / 2) * (index ? -1 : 1) +
                    verandaTyp.log.width / 2,
                  logBarHeight,
                  -verandaTyp.log.depth / 2,
                ]}
              />
            )}
          </group>
        )
      })}
    </>
  )
}
